import * as React from "react"
import { createIcon } from "@chakra-ui/react"

export const EthHomeIcon = createIcon({
  displayName: "EthHomeIcon",
  viewBox: "0 0 115 182",
  defaultProps: {
    width: "22px",
    height: "35px",
  },
  path: [
    // Base shape of the crown
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="739.000000pt"
      height="561.000000pt"
      viewBox="0 0 739.000000 561.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,561.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M3741 4939 l4 -212 49 -53 c34 -38 52 -51 61 -44 17 14 115 204 115
   223 0 9 -30 55 -66 104 -68 89 -94 121 -79 94 5 -9 4 -12 -3 -7 -6 4 -9 13 -6
   20 3 8 -10 26 -28 41 -18 15 -26 23 -18 19 13 -7 13 -5 1 9 -31 38 -34 18 -30
   -194z"
        />
        <path d="M3756 4697 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
        <path
          d="M3620 4594 c-19 -49 -8 -64 45 -64 37 0 40 -19 9 -51 -21 -22 -30
   -26 -37 -17 -5 9 -6 6 -3 -7 4 -12 7 -47 9 -78 2 -50 4 -55 15 -40 7 10 18 17
   23 15 6 -1 8 2 4 8 -4 6 11 30 32 54 21 24 53 62 71 85 18 22 44 44 57 47 21
   5 22 9 13 35 l-10 29 -35 -29 c-29 -24 -40 -28 -63 -21 -23 7 -29 5 -33 -11
   -4 -16 -9 -15 -44 17 -21 20 -37 40 -35 45 5 20 -9 7 -18 -17z"
        />
        <path
          d="M1621 4483 c2 -21 -1 -108 -6 -194 l-8 -157 73 -38 c47 -25 79 -49
   89 -67 9 -16 26 -45 39 -64 l23 -35 -26 6 c-20 5 -25 4 -19 -6 6 -10 3 -9 -9
   1 -16 13 -17 -45 -17 -923 0 -585 -4 -936 -10 -936 -5 0 -13 6 -17 14 -10 17
   -785 820 -865 896 l-59 55 43 36 c24 19 58 45 75 58 l33 22 -29 37 c-25 32
   -31 51 -41 137 -6 55 -15 103 -19 108 -4 4 -45 -23 -90 -60 -46 -38 -89 -72
   -96 -77 -9 -7 -49 14 -131 67 -65 42 -119 75 -120 74 -2 -3 80 -328 88 -349 4
   -9 25 -26 46 -37 36 -18 42 -27 72 -113 18 -51 51 -131 72 -178 22 -47 69
   -152 104 -235 36 -82 70 -153 77 -157 6 -4 8 -8 2 -8 -7 0 -7 -3 0 -8 21 -15
   395 -583 390 -592 -3 -5 0 -12 6 -16 8 -4 9 -3 5 4 -4 7 -5 12 -3 12 2 0 16
   -18 31 -40 22 -34 23 -39 7 -28 -11 6 -17 16 -15 20 3 4 0 8 -5 8 -10 0 -15
   -14 -12 -32 0 -4 -6 -5 -14 -2 -8 4 -15 1 -15 -6 0 -7 -7 -10 -15 -7 -7 3 -24
   -3 -37 -14 -13 -11 -17 -18 -10 -14 12 6 16 -5 13 -37 -1 -10 3 -18 9 -18 6 0
   8 -5 4 -12 -4 -6 -3 -8 3 -5 14 9 78 -53 79 -75 1 -10 -2 -18 -7 -18 -5 0 -9
   6 -9 14 0 8 -8 24 -18 37 -15 17 -21 19 -27 9 -5 -9 -4 -11 3 -6 11 7 16 -7
   15 -41 -1 -7 3 -13 9 -13 5 0 6 -5 3 -10 -3 -6 -2 -10 3 -10 5 0 9 -6 9 -14 0
   -7 23 -68 52 -136 38 -89 49 -125 42 -134 -6 -7 -7 -16 -3 -20 4 -4 2 -6 -5
   -4 -6 2 -11 1 -11 -2 -1 -3 -21 -27 -46 -54 l-45 -48 16 -32 c9 -17 21 -34 27
   -38 6 -4 8 -8 4 -8 -8 0 16 -29 107 -127 73 -79 115 -135 115 -152 0 -6 10
   -11 23 -12 12 0 0 -7 -28 -15 -27 -8 -58 -12 -67 -10 -10 2 -16 0 -15 -4 2 -9
   -150 -117 -395 -281 -80 -54 -149 -102 -152 -107 -5 -8 40 -23 364 -119 l115
   -35 158 13 c86 7 157 15 157 19 0 4 -15 11 -32 17 -18 6 -84 35 -147 63 -104
   47 -119 51 -165 46 -162 -19 -236 -18 -236 3 0 4 88 50 194 101 107 52 193 97
   191 101 -3 4 2 10 11 13 8 3 12 2 9 -4 -3 -6 1 -7 9 -4 9 3 13 11 9 17 -4 6 0
   8 11 4 9 -4 14 -3 11 2 -3 5 -1 12 5 16 6 4 8 11 5 16 -4 5 1 9 9 9 9 0 21 9
   28 20 7 11 17 20 21 20 5 0 21 9 35 20 20 16 39 21 86 19 34 0 93 4 131 10 39
   6 140 15 225 21 85 5 211 14 280 19 220 17 616 32 673 25 67 -8 147 3 146 19
   0 7 -29 37 -65 67 -36 30 -130 125 -209 210 -79 85 -165 176 -192 202 l-49 48
   -138 -9 c-76 -5 -140 -11 -142 -14 -5 -5 67 -62 78 -62 3 0 10 -4 15 -9 5 -6
   2 -6 -7 -1 -8 5 -12 4 -7 0 10 -12 38 -15 31 -4 -3 5 -1 9 4 9 10 0 26 -29 24
   -42 -1 -5 1 -7 6 -7 18 3 24 -2 14 -14 -9 -10 -1 -24 36 -58 l47 -44 -40 46
   c-22 25 -14 18 19 -15 32 -34 63 -61 70 -61 6 0 11 -5 11 -12 0 -15 192 -180
   230 -198 28 -13 26 -13 -52 -14 -74 -1 -84 1 -113 26 -39 32 -261 298 -386
   462 -7 8 -663 -57 -740 -74 -17 -4 -22 -17 -33 -94 -11 -81 -11 -92 5 -123 10
   -18 19 -44 20 -58 1 -14 2 -25 3 -25 2 0 4 -9 6 -19 3 -16 0 -15 -22 7 -15 14
   -27 36 -29 49 -1 13 -3 26 -3 31 -1 4 -6 7 -12 7 -5 0 -8 -4 -4 -9 3 -6 0 -13
   -7 -18 -7 -4 -19 -20 -27 -36 -14 -26 -41 -38 -41 -17 0 6 -6 10 -14 8 -16 -3
   -220 192 -211 201 4 3 55 17 114 32 100 25 111 30 149 70 23 24 42 51 42 60 0
   23 -25 31 -56 18 -15 -5 -29 -7 -32 -5 -2 3 7 8 22 12 21 5 24 9 15 25 -13 25
   -1 24 27 -2 21 -20 23 -20 110 -4 49 9 96 17 104 17 8 0 60 6 115 14 169 23
   381 43 585 56 107 6 197 13 199 15 3 2 -29 38 -71 81 -61 62 -78 85 -84 117
   -3 22 -11 49 -17 60 -6 11 -12 26 -13 33 -1 7 -8 20 -15 28 -12 14 -14 14 -27
   -3 -13 -16 -14 -16 -8 10 5 19 3 26 -4 22 -5 -3 -10 1 -10 10 0 9 4 13 10 10
   6 -3 7 1 4 9 -3 9 -11 13 -17 9 -6 -4 -8 3 -3 21 4 18 3 25 -4 21 -5 -3 -10 1
   -10 10 0 9 4 13 10 10 6 -3 7 1 4 9 -3 9 -11 13 -16 9 -7 -4 -9 4 -6 20 3 15
   2 24 -2 22 -4 -2 -19 42 -34 98 -201 763 -472 1810 -500 1930 -4 15 -11 25
   -15 22 -15 -8 -19 17 -8 55 13 51 27 61 27 19 0 -18 12 -65 26 -104 14 -38 45
   -127 69 -196 87 -251 326 -884 335 -887 5 -2 6 -10 3 -19 -5 -12 -3 -14 6 -8
   9 5 12 21 8 49 -4 38 -4 39 7 14 l11 -26 12 24 c6 13 7 22 2 18 -5 -3 -9 7 -9
   23 0 22 2 25 10 13 8 -12 10 -10 10 9 0 16 4 21 15 18 8 -4 17 -1 21 5 4 7 3
   8 -4 4 -13 -8 -15 4 -6 28 3 9 17 16 31 16 22 0 24 2 13 15 -11 13 -10 14 6 9
   18 -7 18 -6 3 12 -9 10 -14 24 -12 31 10 28 61 -43 171 -237 63 -113 141 -251
   173 -307 l58 -102 -137 -122 c-75 -66 -141 -126 -146 -133 -7 -11 65 -223 225
   -658 l43 -118 62 0 c37 0 65 5 71 13 10 12 155 512 189 652 l18 70 9 -35 c5
   -19 24 -123 42 -230 18 -107 34 -186 34 -175 1 17 3 17 11 5 8 -13 10 -13 10
   1 0 9 9 27 19 41 20 25 22 43 8 66 -5 7 -4 12 2 12 6 0 11 17 11 38 0 26 -6
   41 -20 50 -11 7 -20 21 -20 33 0 11 4 18 9 14 18 -10 21 13 4 26 -9 8 -14 9
   -10 3 3 -6 0 -11 -8 -11 -10 0 -12 5 -5 16 7 12 1 23 -23 44 -18 16 -25 26
   -17 22 8 -4 4 3 -9 14 -13 12 -20 21 -16 21 3 0 -2 12 -12 28 -11 15 -38 72
   -62 127 -98 230 -148 330 -162 327 -8 -2 -11 -1 -7 3 4 4 -19 46 -51 94 -32
   47 -70 109 -84 136 -23 45 -170 263 -633 935 -86 124 -177 256 -204 294 l-48
   70 56 50 c30 28 62 56 70 62 13 9 8 16 -31 39 -33 19 -47 33 -47 48 0 12 -7
   35 -15 50 -8 15 -10 25 -5 22 6 -4 8 4 6 17 -3 13 -5 52 -6 88 l-1 65 -49 -53
   c-28 -30 -48 -57 -45 -62 2 -4 -9 -24 -25 -45 -16 -21 -27 -41 -24 -46 3 -5
   -2 -6 -10 -3 -9 3 -17 10 -17 15 -1 5 -2 13 -3 19 0 5 -8 15 -16 22 -12 11
   -12 10 0 -7 14 -18 14 -19 -2 -6 -10 7 -16 17 -13 21 3 5 -6 25 -20 46 -14 20
   -25 33 -25 28 0 -5 8 -20 17 -33 9 -14 11 -21 5 -17 -7 4 -21 25 -32 47 -11
   21 -25 39 -31 39 -6 0 -8 4 -5 9 3 5 -6 16 -19 25 l-26 17 2 -38z m1667 -2759
   c-1 -5 -9 -9 -16 -10 -10 -2 -11 1 -1 12 12 14 24 13 17 -2z m-1314 -656 c4 6
   14 8 23 5 11 -5 14 -3 9 6 -6 8 2 7 23 -3 17 -9 31 -19 31 -22 0 -3 -5 -2 -12
   2 -7 4 -8 3 -4 -5 4 -6 11 -9 16 -6 5 3 63 -31 129 -75 70 -47 126 -78 132
   -74 7 4 9 3 6 -3 -4 -6 36 -44 88 -84 l94 -74 -102 -6 c-56 -4 -118 -8 -137
   -9 -96 -6 -240 1 -240 11 0 7 -29 68 -64 138 -70 139 -82 172 -89 246 l-5 50
   48 -54 c28 -32 50 -49 54 -43z m-7 36 c3 -8 10 -11 17 -7 6 4 5 -1 -3 -10 -11
   -13 -17 -15 -28 -6 -7 7 -11 14 -8 17 2 3 -3 11 -13 18 -15 12 -15 12 6 7 13
   -3 26 -12 29 -19z m-273 -304 c-6 -6 -10 -2 -11 12 -2 16 1 18 10 9 7 -7 8
   -14 1 -21z"
        />
        <path
          d="M5817 4494 c-20 -19 -26 -31 -21 -49 5 -20 -31 -222 -42 -234 -2 -2
   -15 4 -29 13 l-25 16 0 -84 c0 -47 4 -87 9 -90 5 -4 41 11 81 31 l71 38 -7
   190 c-3 105 -7 191 -8 192 -1 1 -14 -9 -29 -23z"
        />
        <path
          d="M3870 4419 c-16 -39 -9 -86 129 -774 60 -297 107 -542 105 -544 -3
   -3 -221 170 -326 259 l-38 31 0 -1006 0 -1006 55 63 c48 54 314 394 467 595
   l47 63 6 -38 c4 -20 11 -52 16 -71 4 -19 6 -38 3 -43 -10 -16 -23 -7 -27 20
   -2 15 -3 7 -2 -17 2 -24 9 -47 16 -52 10 -6 10 -9 2 -9 -7 0 -17 8 -23 17 -9
   14 -10 9 -8 -24 2 -24 1 -43 -3 -43 -5 0 -37 -234 -56 -411 l-5 -46 224 -11
   c122 -7 342 -20 488 -29 146 -9 295 -18 331 -21 l67 -4 67 129 c111 209 127
   237 148 261 11 12 17 22 14 22 -9 0 51 119 68 137 11 10 15 10 19 0 3 -6 3 2
   -1 18 -3 17 -2 27 2 22 5 -4 19 28 31 70 l23 78 1 948 0 947 -52 24 c-52 22
   -53 22 -61 3 -4 -10 -41 -173 -83 -361 -42 -187 -98 -435 -125 -551 -57 -239
   -222 -971 -246 -1087 -9 -43 -19 -78 -23 -78 -4 0 -29 83 -55 184 l-49 184
   -237 115 -238 115 -24 48 c-33 66 -180 512 -391 1189 -36 116 -101 321 -143
   457 -43 136 -83 250 -90 252 -6 3 -17 -9 -23 -25z m487 -2543 c-3 -7 -1 -18 5
   -24 6 -6 7 -15 4 -21 -10 -16 -26 -13 -20 3 3 8 1 17 -5 20 -12 8 -3 36 11 36
   6 0 8 -6 5 -14z m-30 -78 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
   m48 -56 c-11 -29 -25 8 -14 37 l9 26 -20 -24 c-11 -13 -20 -20 -20 -15 0 4 10
   19 23 32 l22 24 3 -32 c2 -18 1 -39 -3 -48z m25 -52 c0 -5 -2 -10 -4 -10 -3 0
   -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m18 -61 c0 -16 -3 -27 -8 -24
   -4 3 -7 13 -5 23 1 9 -2 23 -8 30 -7 9 -6 11 5 7 8 -3 15 -19 16 -36z m25 -95
   c-6 -17 -23 -9 -23 11 0 8 6 12 14 9 8 -3 12 -12 9 -20z m19 -88 c-8 -14 -20
   27 -14 44 4 11 8 8 12 -10 4 -14 5 -29 2 -34z"
        />
        <path
          d="M3592 4385 c-12 -14 -28 -25 -34 -25 -8 0 -27 -47 -46 -113 -40 -135
   -269 -856 -428 -1346 -103 -316 -122 -386 -96 -355 5 5 46 54 92 109 46 55
   117 136 157 181 l72 81 76 349 c129 593 146 678 140 709 -4 24 -3 26 4 10 9
   -19 10 -19 10 2 1 12 15 82 31 155 25 108 28 135 17 143 -16 12 -7 63 17 100
   21 32 16 32 -12 0z"
        />
        <path
          d="M5507 4318 c-4 -12 -7 -35 -7 -49 0 -28 -22 -53 -60 -67 -25 -10 -24
   -10 38 -73 80 -80 89 -74 72 45 -10 70 -10 89 1 102 10 13 8 19 -13 40 l-25
   26 -6 -24z m8 -208 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20
   -13 20 3 0 13 -9 23 -20z"
        />
        <path
          d="M5615 4060 c-23 -25 -13 -37 14 -18 12 8 17 19 12 26 -5 9 -12 7 -26
   -8z"
        />
        <path
          d="M5563 3990 c-3 -11 -40 -97 -83 -190 -43 -94 -74 -168 -69 -164 14 8
   11 -3 -7 -20 -9 -9 -11 -16 -4 -16 6 0 8 -5 5 -10 -4 -6 -12 -7 -18 -3 -7 4
   -5 -2 3 -12 14 -17 13 -18 -2 -12 -13 4 -15 2 -11 -10 5 -12 3 -14 -7 -8 -9 5
   -11 4 -6 -4 4 -6 12 -9 17 -6 5 4 9 -4 9 -17 1 -23 1 -23 25 5 25 28 25 28 25
   5 1 -50 61 147 100 327 10 44 25 97 34 118 10 24 12 37 5 37 -6 0 -13 -9 -16
   -20z"
        />
        <path
          d="M6604 3385 c4 -45 3 -54 -4 -35 -8 19 -9 13 -5 -29 5 -56 19 -85 39
   -75 6 3 2 -2 -8 -10 -27 -22 -34 -20 -39 12 -4 24 -4 24 -3 -4 1 -22 -7 -40
   -30 -64 l-32 -33 67 -52 c36 -28 66 -56 66 -62 0 -6 -71 -86 -158 -177 -87
   -91 -155 -166 -151 -166 4 0 -3 -11 -16 -25 -13 -14 -20 -28 -17 -32 4 -3 2
   -12 -3 -18 -7 -9 -6 -16 4 -24 13 -11 3 -26 -62 -103 -42 -49 -88 -102 -101
   -118 -18 -23 -31 -69 -57 -197 -70 -347 -128 -608 -135 -611 -4 -2 -5 -13 -2
   -25 4 -18 3 -19 -7 -7 -9 12 -10 8 -5 -19 4 -20 3 -31 -2 -28 -11 7 -37 -58
   -29 -71 3 -5 -27 -24 -67 -43 -39 -19 -90 -49 -114 -66 -42 -32 -43 -32 -112
   -24 -38 5 -75 12 -82 17 -7 4 3 -14 21 -40 19 -26 38 -50 42 -52 5 -3 8 -10 8
   -16 0 -7 -21 -9 -63 -4 l-63 6 -59 -60 c-53 -54 -60 -66 -31 -61 5 1 6 -5 3
   -14 -4 -8 -1 -15 6 -15 8 0 7 -4 -3 -10 -8 -5 -11 -12 -7 -16 4 -4 -1 -16 -10
   -27 -10 -11 -12 -17 -5 -13 6 4 12 2 12 -4 0 -6 4 -8 10 -5 5 3 -13 -17 -40
   -45 -28 -28 -54 -49 -59 -46 -5 3 -15 -2 -22 -12 -12 -15 -12 -16 1 -7 9 6 7
   2 -3 -7 -11 -10 -23 -15 -28 -12 -5 3 -8 0 -7 -8 2 -7 -5 -13 -14 -13 -9 0
   -20 -4 -25 -9 -5 -5 -2 -6 7 -2 25 13 -33 -34 -63 -50 -21 -11 -43 -13 -83 -8
   -30 3 -54 10 -54 14 0 4 41 41 90 81 50 40 90 77 90 83 0 6 -21 74 -47 152
   l-47 142 -44 6 c-25 3 -93 6 -151 6 l-106 0 -195 -196 c-107 -107 -216 -214
   -243 -236 -26 -22 -45 -43 -42 -48 6 -9 -74 -6 -175 7 -41 6 -139 7 -217 4
   -155 -7 -149 -10 -94 54 20 22 21 26 6 16 -11 -7 -2 4 20 24 22 21 33 34 25
   29 -9 -5 -7 -1 5 10 11 10 19 20 18 22 -8 12 -1 24 10 17 6 -4 4 6 -7 21 -10
   16 -14 26 -9 23 4 -3 14 6 20 20 10 21 10 23 -2 13 -35 -29 -30 7 12 98 25 53
   49 109 54 125 l8 27 -330 0 -329 0 157 -197 c86 -109 178 -223 205 -254 26
   -31 48 -59 48 -62 0 -3 -15 -1 -32 4 -18 5 -98 9 -178 9 -144 0 -144 0 -125
   -20 20 -19 37 -20 508 -24 468 -3 489 -2 500 15 7 11 17 19 24 19 7 0 22 9 33
   20 11 11 20 17 20 13 0 -4 7 2 16 13 8 10 13 12 9 4 -4 -8 3 -4 15 10 12 14
   19 18 15 10 -4 -8 1 -6 10 5 9 11 18 19 20 18 8 -5 7 8 -1 15 -4 4 -4 1 1 -7
   6 -10 4 -12 -4 -7 -9 6 -9 11 0 22 13 16 23 19 14 5 -3 -6 3 -9 14 -8 11 0 19
   6 18 12 -1 5 5 11 13 11 8 1 19 2 24 3 11 1 -33 51 -45 51 -4 0 -6 -12 -3 -27
   3 -23 2 -25 -6 -11 -6 9 -17 15 -25 12 -8 -4 -12 -10 -9 -15 3 -5 -2 -6 -10
   -3 -9 3 -13 10 -10 15 6 10 59 39 71 40 5 0 12 7 16 15 5 8 12 12 17 9 4 -3
   11 2 14 11 3 9 13 14 21 10 8 -3 17 0 21 6 5 7 2 8 -6 3 -9 -5 -11 -4 -6 3 5
   9 13 9 29 0 21 -11 21 -10 7 7 -9 11 -10 16 -2 11 6 -4 12 -2 12 3 0 6 3 10 8
   10 19 -3 33 3 53 24 12 12 18 15 13 7 -10 -19 45 14 64 38 6 9 12 13 12 9 0
   -4 10 -2 23 5 12 7 24 12 27 13 3 0 21 12 40 26 35 27 74 49 84 49 4 0 -16
   -35 -43 -78 -123 -192 -200 -325 -194 -335 3 -5 2 -7 -4 -4 -5 3 -17 -7 -27
   -24 -16 -27 -21 -29 -80 -29 -47 0 -70 -5 -86 -18 -28 -22 -46 -19 205 -32
   110 -6 216 -15 235 -20 19 -6 69 -10 110 -10 41 0 107 -5 146 -10 72 -9 81
   -13 299 -130 39 -21 115 -61 170 -90 55 -29 123 -65 150 -81 28 -15 64 -35 80
   -44 29 -15 25 -16 -85 -10 -153 7 -774 26 -858 26 -37 0 -224 2 -417 5 -229 4
   -347 3 -340 -4 6 -5 48 -37 94 -71 l85 -61 105 0 c246 0 989 -38 1296 -66
   l160 -14 253 72 c138 40 252 75 252 79 0 3 -33 28 -72 54 -90 59 -460 315
   -471 325 -5 4 32 97 82 206 50 110 91 203 91 208 0 5 -25 38 -56 73 -68 77
   -75 42 66 353 126 279 123 272 375 855 114 264 224 527 244 585 35 99 40 107
   83 135 26 17 47 36 47 44 1 8 17 84 37 169 19 84 33 156 31 158 -6 7 -167 -95
   -193 -122 -17 -18 -20 -33 -20 -98 1 -42 0 -76 -1 -76 -10 0 -82 117 -79 127
   4 8 -3 13 -17 13 -18 0 -32 18 -70 88 l-48 87 5 -60z m-194 -638 c0 -2 -15
   -16 -32 -33 l-33 -29 29 33 c28 30 36 37 36 29z m-486 -1586 c22 -19 11 -31
   -30 -31 -38 0 -39 2 -22 29 13 21 28 22 52 2z m-504 -54 c0 -2 -10 -12 -22
   -23 l-23 -19 19 23 c18 21 26 27 26 19z m24 -116 c3 -5 -1 -14 -8 -20 -12 -10
   -14 -9 -11 6 2 10 4 19 4 21 2 5 10 2 15 -7z m-489 -241 c-11 -5 -29 -8 -40
   -8 -16 0 -15 2 5 8 34 11 60 11 35 0z m-567 -7 c-10 -2 -28 -2 -40 0 -13 2 -5
   4 17 4 22 1 32 -1 23 -4z"
        />
        <path
          d="M5900 1166 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
   13z"
        />
        <path
          d="M3296 1902 c-3 -6 1 -15 8 -21 8 -7 17 -8 20 -3 3 6 -1 15 -8 21 -8
   7 -17 8 -20 3z"
        />
        <path
          d="M3329 1870 c-5 -17 -5 -50 -1 -45 3 3 14 -3 24 -12 24 -22 54 -28 37
   -7 -6 7 -15 11 -20 8 -5 -3 -10 0 -10 5 -1 6 -2 15 -3 21 -1 10 -25 36 -27 30z"
        />
        <path
          d="M3320 1790 c0 -13 5 -18 15 -14 12 5 13 10 4 20 -15 19 -19 18 -19
   -6z"
        />
        <path d="M3413 1755 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z" />
        <path d="M1265 1719 c-11 -17 1 -21 15 -4 8 9 8 15 2 15 -6 0 -14 -5 -17 -11z" />
        <path d="M3453 1705 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z" />
        <path d="M1180 1693 c0 -15 18 -35 23 -27 3 5 -1 15 -9 22 -8 7 -14 9 -14 5z" />
        <path
          d="M3263 1616 c3 -8 1 -17 -6 -19 -9 -3 -8 -8 2 -18 8 -8 11 -9 7 -2 -3
   6 2 16 11 22 11 6 13 11 5 11 -7 0 -10 5 -7 10 3 6 1 10 -5 10 -7 0 -10 -6 -7
   -14z"
        />
        <path
          d="M3283 1493 c-3 -10 -8 -21 -10 -25 -2 -4 2 -5 9 -3 8 3 14 14 14 25
   0 25 -5 25 -13 3z"
        />
        <path
          d="M3285 1450 c-4 -6 -4 -24 0 -40 l7 -30 91 2 c91 2 91 2 19 5 -56 3
   -79 9 -94 23 -18 16 -19 22 -8 35 8 9 8 15 2 15 -6 0 -14 -5 -17 -10z"
        />
        <path d="M5551 1384 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
        <path
          d="M4796 1021 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4
   -12 2 -15 -3z"
        />
        <path
          d="M3916 972 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
   -9 -8z"
        />
        <path
          d="M4720 965 c-11 -13 -15 -13 -22 -3 -8 10 -9 10 -6 -1 2 -8 12 -15 22
   -17 10 -1 15 0 12 3 -3 4 -1 12 5 20 6 7 9 13 6 13 -2 0 -10 -7 -17 -15z"
        />
        <path
          d="M4653 958 c-26 -13 -28 -21 -10 -35 17 -14 44 -12 44 3 0 7 -7 10
   -15 7 -12 -5 -12 -2 -3 15 7 12 10 22 9 21 -2 0 -13 -5 -25 -11z"
        />
        <path
          d="M1626 910 c5 -8 9 -25 8 -37 0 -13 6 -28 15 -35 14 -11 14 -11 5 2
   -6 8 -10 25 -9 38 1 12 -5 28 -14 35 -13 10 -14 10 -5 -3z"
        />
        <path
          d="M2695 320 l-150 -5 38 -23 c20 -13 34 -28 31 -34 -4 -7 -2 -8 4 -4 7
   4 12 2 12 -3 0 -6 3 -10 8 -9 16 5 51 -23 46 -37 -5 -12 4 -15 42 -16 99 -2
   489 3 492 6 2 1 -5 32 -14 69 l-16 66 -172 -2 c-94 -1 -238 -5 -321 -8z"
        />
        <path d="M3666 264 l-68 -64 76 0 76 0 -1 48 c-1 86 -6 87 -83 16z" />
        <path
          d="M2315 309 c-418 -12 -640 -22 -659 -29 -18 -6 -13 -14 40 -68 43 -45
   55 -63 44 -66 -19 -6 236 4 272 10 l26 5 -17 64 -18 63 96 -50 c53 -28 100
   -54 106 -59 12 -12 142 -12 147 0 2 5 22 12 46 16 36 6 42 4 42 -10 0 -14 6
   -16 31 -11 17 3 49 6 71 6 l39 0 -21 28 c-11 15 -24 45 -28 67 l-7 40 -210 -6z"
        />
        <path
          d="M4244 254 l-50 -54 47 0 c47 0 47 0 47 34 0 19 3 43 7 55 3 12 5 21
   3 20 -2 0 -26 -25 -54 -55z"
        />
      </g>
    </svg>,
  ],
})
